import styled from "styled-components";

export const StyledModalView = styled.div`
.modalSection {
    margin: 42px 25px 21px 25px;
}

.modalClose {
    margin-left: auto;
    display: block;
    cursor: pointer;
}

.modalDescription {
    height: 44px;
    color: rgba(53,64,82,0.7);
    font-family: Gelion;
    font-size: 15px;
    line-height: 22px;
}

.modalFields {
    border-bottom: 1px solid rgba(53,64,82,0.3);
}

.modalLabel {
    height: 14px;
    color: #354052;
    font-family: Gelion;
    font-size: 15px;
    line-height: 19px;
    margin-bottom: 4.5px;
    font-weight: normal;
}

.modalInput {
    box-sizing: border-box;
    padding: 6px 20px;
    border: 1px solid #D3DAE0;
    border-radius: 2px;
}

.modalTextarea {
    border: 1px solid #D3DAE0;
    border-radius: 2px;
    min-height: 70px;
    width: 100%;
    min-width: 100%;
    resize: none;
    padding: 6px 20px;
}

.modalSubText {
    color: rgba(53,64,82,0.7);
    font-family: Gelion;
    font-size: 12px;
    line-height: 18px;
    margin-top: 13px;
}

.modalFooter {
    display: flex;
    justify-content: flex-end;
    margin-top: 21px;
}

.modalButtons {
    display: flex;
}

.modalButton {
    width: 100px;
    border: 1px solid rgba(53,64,82,0.5);
    border-radius: 2px;
    text-align: center;
    color: rgba(53,64,82,0.5);
    font-family: Gelion;
    font-size: 15px;
    line-height: 19px;
    text-align: center;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    cursor: pointer;
}

.modalButton:last-child {
    margin-right: 0;
}

.modalButton.cancel {
    background-color: #ffffff;
    color: rgba(53,64,82,0.5);
}

.modalButton.create {
    background-color: #354052;
    color: #FFFFFF;
}

.modalButton.delete {
    background-color: #EC4B5F;
    color: #FFFFFF;
    border: 1px solid #EC4B5F;
}

.modalError {
    color: #EC4B5F;
}

.modalRightSide {
    padding: 0 0 0 60px;
    border-left: 1px solid rgba(53,64,82,0.3);
}

.addMoreModalFieldsWrapper {
    border-bottom: 1px solid rgba(53,64,82,0.3);
}
`;


// WEBPACK FOOTER //
// ./src/presentations/views/ModalView/style.ts